import { render, staticRenderFns } from "./BasicContainer.vue?vue&type=template&id=f391bd3a&"
import script from "./BasicContainer.vue?vue&type=script&lang=js&"
export * from "./BasicContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports